import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";

export const CATS = [["", "All"], ["cricket", "Cricket"], ["casino", "Casino"]];

export const BlogFilters = ({ cat, q, onCat, onSearch }) => {
  const [text, setText] = useState(q);
  useEffect(() => { setText(q); }, [q]);
  useEffect(() => {
    if (text === q) return undefined;
    const id = setTimeout(() => onSearch(text.trim()), 400);
    return () => clearTimeout(id);
  }, [text]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between" data-testid="blog-filters">
      <div className="flex w-fit rounded-full border border-[#D4AF37]/30 bg-black/30 p-1" role="tablist" aria-label="Blog categories">
        {CATS.map(([k, l]) => (
          <button key={k || "all"} role="tab" aria-selected={cat === k} onClick={() => onCat(k)} data-testid={`blog-cat-${k || "all"}`}
            className={`rounded-full px-5 py-2 text-xs font-semibold uppercase tracking-widest transition-colors ${cat === k ? "bg-gradient-to-b from-[#F3D77A] to-[#D4AF37] text-black" : "text-[#D4AF37] hover:bg-[#D4AF37]/10"}`}>{l}</button>
        ))}
      </div>
      <form role="search" onSubmit={(e) => { e.preventDefault(); onSearch(text.trim()); }} className="relative w-full lg:max-w-sm">
        <Search size={16} className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[#D4AF37]" />
        <input type="search" value={text} onChange={(e) => setText(e.target.value)} maxLength={80} placeholder="Search articles…" aria-label="Search articles"
          className="h-12 w-full rounded-full border border-[#D4AF37]/30 bg-black/40 pl-11 pr-11 text-sm text-white placeholder:text-zinc-500 outline-none transition-colors focus:border-[#D4AF37] [&::-webkit-search-cancel-button]:hidden" data-testid="blog-search" />
        {text && <button type="button" onClick={() => { setText(""); onSearch(""); }} aria-label="Clear search" className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-zinc-400 hover:text-white" data-testid="blog-search-clear"><X size={16} /></button>}
      </form>
    </div>
  );
};
